var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"ls-alert",attrs:{"type":_vm.alert.options.type,"min-width":"100","transition":"slide-x-reverse-transition","dismissible":""},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_vm._v(" "+_vm._s(_vm.alert.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }